import { render, staticRenderFns } from "./advancedForm.vue?vue&type=template&id=50235c2a&scoped=true"
import script from "./advancedForm.vue?vue&type=script&lang=js"
export * from "./advancedForm.vue?vue&type=script&lang=js"
import style0 from "./advancedForm.vue?vue&type=style&index=0&id=50235c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50235c2a",
  null
  
)

export default component.exports